<template>
    <v-container fill>
        <div class="text-center">
            <v-row no-gutters>
                <v-col class="d-flex pr-2 pt-1">
                    <v-text-field-filled
                        v-model="searchUser"
                        label="Rechercher"
                        append-inner-icon="$search"
                        clearable
                        @click:append-inner="searchUser = ''"
                    />
                </v-col>
                <v-col class="d-flex flex-grow-0 flex-shrink-1 pl-2 align-center justify-center">
                    <v-btn-add rounded="xl" :disabled="!enableUserWrite" @click="emitStep()">
                    </v-btn-add>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="pt-2">
                    <v-tabs v-model="activeTab" class="tab_budget_form_mobile" color="secondary">
                        <v-tab
                            ripple
                            v-if="showUsers"
                            value="showUsers"
                            href="#showUsers"
                            data-cy="selectUser-showUser-tab"
                            @click="emptyMergingList()"
                            >Utilisateurs</v-tab
                        >
                        <v-tab
                            ripple
                            v-if="showOrphelinUsers"
                            value="showOrphelinUsers"
                            href="#showOrphelinUsers"
                            data-cy="selectUser-showOrphelinUsers-tab"
                            @click="emptyMergingList()"
                            >Utilisateurs Orphelins</v-tab
                        >
                    </v-tabs>
                    <!-- Users -->
                    <v-window v-model="activeTab" class="mt-2">
                        <v-window-item v-if="showUsers" value="showUsers">
                            <v-row no-gutters>
                                <v-col cols="12" class="mb-2">
                                    <v-btn
                                        elevation="0"
                                        class="mr-2"
                                        rounded="xl"
                                        :disabled="!enableUserWrite"
                                        @click="selectAllUsers(filtredUsers)"
                                        data-cy="UserEdition-allCompanies"
                                        size="small"
                                        variant="flat"
                                    >
                                        Sélectionner tous les utilisateurs
                                    </v-btn>
                                    <v-btn
                                        elevation="0"
                                        rounded="xl"
                                        :disabled="!enableUserWrite"
                                        @click="diselectAllUsers()"
                                        data-cy="UserEdition-notAllCompanies"
                                        size="small"
                                        variant="flat"
                                    >
                                        Désélectionner tous les utilisateurs
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="h-100 overflow-y-auto">
                                <v-col cols="12">
                                    <v-virtual-scroll
                                        :items="filtredUsers"
                                        height="400"
                                        width="1000"
                                        item-height="48"
                                    >
                                        <template #default="{ item: user }">
                                            <v-list-item
                                                lines="one"
                                                border
                                                rounded="xl"
                                                density="compact"
                                                :title="getUserDisplayName(user)"
                                                :subtitle="user.email ? user.email : ''"
                                                class="mb-2"
                                                @click.stop="editUser(user)"
                                            >
                                                <template #prepend>
                                                    <v-checkbox
                                                        v-model="selectedUsers"
                                                        class="pa-0 ma-0"
                                                        @click.stop="selectUser(user.id)"
                                                        :value="isSelectedUser(user.id)"
                                                    />
                                                </template>
                                                <template #append class="my-0">
                                                    <v-btn-next />
                                                </template>
                                            </v-list-item>
                                        </template>
                                    </v-virtual-scroll>
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item v-if="showOrphelinUsers" value="showOrphelinUsers">
                            <v-row no-gutters>
                                <v-col cols="12" class="mb-2">
                                    <v-btn
                                        elevation="0"
                                        class="mr-2"
                                        rounded="xl"
                                        variant="flat"
                                        @click="selectAllUsers(orphelinUsers)"
                                        :disabled="!enableUserWrite"
                                        data-cy="UserEdition-allCompanies"
                                        size="small"
                                    >
                                        Sélectionner tous les utilisateurs
                                    </v-btn>
                                    <v-btn
                                        elevation="0"
                                        rounded="xl"
                                        variant="flat"
                                        @click="diselectAllUsers()"
                                        :disabled="!enableUserWrite"
                                        data-cy="UserEdition-notAllCompanies"
                                        size="small"
                                    >
                                        Désélectionner tous les utilisateurs
                                    </v-btn>
                                </v-col>
                                <v-col cols="12">
                                    <v-virtual-scroll
                                        :items="orphelinUsers"
                                        height="400"
                                        width="1000"
                                        item-height="48"
                                    >
                                        <template #default="{ item: user }">
                                            <v-list-item
                                                class="mb-2"
                                                lines="two"
                                                border
                                                rounded="xl"
                                                density="compact"
                                                :title="getUserDisplayName(user)"
                                                :subtitle="user.email ? user.email : ''"
                                            >
                                                <template #prepend>
                                                    <v-checkbox
                                                        v-model="selectedUsers"
                                                        class="pa-0 ma-0"
                                                        :disabled="!enableUserWrite"
                                                        @click.stop="selectUser(user.id)"
                                                        :value="isSelectedUser(user.id)"
                                                    />
                                                </template>
                                                <template
                                                    #append
                                                    class="my-0"
                                                    style="background: #fff"
                                                >
                                                    <v-btn-trash
                                                        v-model="user.id"
                                                        :disabled="!enableUserWrite"
                                                        @click.stop="confirmToDeleteOrphelin(user)"
                                                    >
                                                    </v-btn-trash>
                                                </template>
                                            </v-list-item>
                                        </template>
                                    </v-virtual-scroll>
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
        </div>
        <oss-dialog
            v-if="confirmDeleteDialog"
            v-model="confirmDeleteDialog"
            title="Suppression Utilisateur"
            @valid="deleteOrphelin(toDeleteUser.id)"
            max-width="40vw"
        >
            <h4>Voulez-vous supprimer l'utilisateur {{ getUserDisplayName(toDeleteUser) }} ?</h4>
        </oss-dialog>
        <oss-dialog
            v-if="multiDeleteDialog"
            v-model="multiDeleteDialog"
            title="Suppression Utilisateurs"
            @valid="deleteOrphelinUsers()"
            max-width="40vw"
        >
            <h4>Voulez-vous supprimer {{ selectedUsers.length }} utilisateur(s) ?</h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers2.gql";
import ORPHELIN_USERS from "../../graphql/user/OrphelinUsers.gql";
import { getUserDisplayName } from "../../services/userServices";
import { Apollo } from "../../decorators";
import { User } from "../../store/store";
import DELETE_USER from "../../graphql/user/DeleteUser.gql";
import DELETE_ORPHELIN_USERS from "../../graphql/user/DeleteOrphelinUsers.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {},
    emits: [
        "users-to-merge",
        "create-user-step",
        "edit-user",
        "disable-merge-button",
        "emit-actions",
    ],
})
export class SelectUserV2 extends Vue {
    @Prop({ default: true }) showUsers!: boolean;
    @Prop({ default: true }) showOrphelinUsers!: boolean;
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: undefined }) readonly type: string;
    @Prop({ default: null }) withEmail: boolean;
    @Prop({ default: null }) actions: any;

    activeTab = "showUsers";

    searchUser = "";

    currentStep = "selectUser";

    selectedUsers = [];

    confirmDeleteDialog = false;

    multiDeleteDialog = false;

    toDeleteUser = {
        id: "",
        firstname: "",
        lastname: "",
    };

    beforeMount() {
        if (this.actions) {
            this.setActions();
        }
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
                type: this.type,
                availableCompanyId: undefined,
            };
            // email_not: this.withEmail ? null:undefined,
        },
        skip() {
            return !this.companyId || !!this.outstanding;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.users) {
                    this.users = JSON.parse(JSON.stringify(data.users));
                    if (this.user && this.user.id) {
                        if (!this.isInList) {
                            data.users.push(this.user);
                        }
                    }
                } else {
                    this.users = [];
                    this.selectUser({});
                }
            }
        },
    })
    users: User[] = [];

    @Apollo({
        query: ORPHELIN_USERS,
        variables() {
            return {
                companyId: this.companyId,
                search: this.searchUser,
            };
        },
        debounce: 500,
        skip() {
            return !this.showOrphelinUsers;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.orphelinUsers) {
                        if (this.infiniteScroll) {
                            this.orphelinUsers.push(...data.orphelinUsers);
                        } else {
                            this.orphelinUsers = data.orphelinUsers;
                        }
                    } else {
                        this.orphelinUsers = [];
                    }
                }
            }
        },
    })
    orphelinUsers: Array<any> = [];

    get filtredUsers() {
        if (!this.searchUser) {
            return this.users;
        }
        return this.users.filter((user) =>
            getUserDisplayName(user).toLowerCase().includes(this.searchUser.toLowerCase()),
        );
    }

    async deleteOrphelin(userIdToDelete) {
        await this.$apollo.mutate({
            mutation: DELETE_USER,
            variables: {
                userId: userIdToDelete,
            },
        });
        this.refresh();

        this.toDeleteUser = {
            id: "",
            firstname: "",
            lastname: "",
        };

        this.confirmDeleteDialog = false;
    }

    confirmToDeleteOrphelin(user) {
        this.toDeleteUser.firstname = user.firstname;
        this.toDeleteUser.lastname = user.lastname;
        this.toDeleteUser.id = user.id;
        this.confirmDeleteDialog = true;
    }

    selectUser(userId) {
        const isSelected = this.isSelectedUser(userId);
        if (isSelected) {
            this.selectedUsers = this.selectedUsers.filter((u) => u.id !== userId);
        } else {
            this.selectedUsers.push({ id: userId });
        }
        if (this.activeTab === "showUsers") {
            this.$emit("users-to-merge", this.selectedUsers);
        }
    }

    isSelectedUser(userId) {
        const isSelected = this.selectedUsers.find((u) => u.id === userId);
        return isSelected;
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    emitStep() {
        this.currentStep = "createUser";
        this.$emit("create-user-step", this.currentStep);
        this.currentStep = "selectUser";
    }

    editUser(user) {
        this.$emit("edit-user", user);
    }

    emptyMergingList() {
        this.$emit("disable-merge-button", true);
        this.selectedUsers = [];
    }

    selectAllUsers(users) {
        for (const user of users) {
            this.selectedUsers.push({ id: user.id });
        }
        this.$emit("users-to-merge", this.selectedUsers);
    }

    diselectAllUsers() {
        this.$emit("disable-merge-button", true);
        this.selectedUsers = [];
    }

    // @Watch("selectedUsers", {deep: true})
    // onSelectedUsersChanged() {
    //     debugger
    //     this.$emit("orphelin-users", (this.selectedUsers || []))
    // }

    // @Watch("activeTab")
    // onActiveTabChanged() {
    //     console.log(this.activeTab)
    //     this.$emit("delete-button", this.activeTab)
    // }
    async deleteOrphelinUsers() {
        if (this.selectedUsers && this.selectedUsers.length) {
            this.selectedUsers = this.selectedUsers.map((u) => u.id);

            try {
                const deletedOrphelinUsers = await this.$apollo.mutate({
                    mutation: DELETE_ORPHELIN_USERS,
                    variables: {
                        userIds: this.selectedUsers,
                    },
                });

                if (deletedOrphelinUsers) {
                    this.selectedUsers = [];
                    this.refresh();
                    this.multiDeleteDialog = false;
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    @Watch("activeTab")
    setActions() {
        if (this.activeTab === "showOrphelinUsers") {
            this.actions.action.function = () => {
                this.multiDeleteDialog = true;
            };
            this.actions.action.title = "Supprimer";
            this.actions.action.disabled = () => {
                return !this.selectedUsers.length;
            };
        } else {
            this.$emit("emit-actions", "");
        }
    }

    get enableUserWrite() {
        return this.currentUser.profile?.configuration?.user?.write;
    }

    refresh() {
        this.$apollo.queries.orphelinUsers.refetch();
        this.$apollo.queries.users.refetch();
    }
}

export default toNative(SelectUserV2);
</script>
